export abstract class BloqueioRegistro{
   mensagemBloqueio: string;
}
